import React from "react";
import Homesection4Card1 from "./Homesection4Card1";

const Homesection4Card = (props) => {
  if (props.row === "upper") {
    return (
      <div className="lg:flex  ">
        <Homesection4Card1
          image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQa7LNBUikawQUNwUlL1k0dBSK0rBtBn7evRA&usqp=CAU"
          title="Well maintained toilets"
        />
        <Homesection4Card1
          image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSDhA87-1h6Pg5WunDRD02uhoDL3iPPzQHjEQ&usqp=CAU"
          title=" Security"
        />
        <Homesection4Card1
          image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTV9Ztkg300hpBiOyzC5bmQMvUxcQwBRXTJsg&usqp=CAU"
          title="Playgrounds & facilities"
        />
      </div>
    );
  } else {
    return (
      <div className="lg:flex">
        <Homesection4Card1
          image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQYmw9_MLez5oc7XhEYf6rRIfpl3cS-1JU00Q&usqp=CAU"
          title="Laboratory
"
        />
        <Homesection4Card1
          image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRvPpeMvQHqU1Ixv6E3jLTMj9G1CguZkys8qA&usqp=CAU"
          title="Space and size of classrooms"
        />
        <Homesection4Card1
          image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTg2_OqW28elWLTqhmTux7Xeek8jipvOVDKEQ&usqp=CAU"
          title="Sanitation"
        />
      </div>
      // y rha ek div uske andar tere teen div component m kya h div hi toh usm isme img or title dala toh 2 div m same aagya h kyuki y dekh
    );
  }
};
// hatha de component chahe toh vrna ese bhi kr skti h deh dikhao
export default Homesection4Card;
